import { useState } from 'react';
import { Button } from '@mui/joy';
import AddIcon from '@mui/icons-material/Add';
import { AddSubcategoryForm } from './AddSubcategoryForm';

export function AddSubcategory({ categoryId, onSubcategoryCreated }) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleSave = (subcategoryData) => {
    setIsFormOpen(false);
    onSubcategoryCreated(subcategoryData);
  };

  const handleCancel = () => {
    setIsFormOpen(false);
  };

  if (isFormOpen) {
    return (
      <AddSubcategoryForm
        categoryId={categoryId}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    );
  }

  return (
    <Button
      size="sm"
      variant="outlined"
      color="neutral"
      startDecorator={<AddIcon />}
      onClick={() => setIsFormOpen(true)}
      sx={{ alignSelf: 'flex-start', width: { xs: '100%', sm: 'auto' }, height: '40px', px: 2.5 }}
    >
      Add Subcategory
    </Button>
  );
}

